import React, { useContext, useState, useEffect } from "react";
import { Dropdown, Navbar } from "flowbite-react";
import img from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { Store } from "../context/store";
import apiRequest from "../utils/apiRequest";
import { confirmDialog } from "./ConfirmDialog";
import { getInitials } from "../utils/formatters";

export default function NavbarWithCTAButton({ toggleSidebar }) {
  const store = useContext(Store);
  const [baseUrl] = store.url;
  const [loggedInUser, setLoggedInUser] = store.loggedInUser;
  const navigate = useNavigate();
  const [, setError] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    const loadUser = async () => {
      try {
        const token = localStorage.getItem("royal-token");
        const { data } = await apiRequest(
          `${baseUrl}/token`,
          "GET",
          null,
          token
        );
        setLoggedInUser(data);
        setName(`${data.firstName} ${data.lastName}`);
      } catch (error) {
        setLoggedInUser({});
        setError("An error occurred. Please try again.");
      }
    };

    loadUser();
  }, [baseUrl, setLoggedInUser, setError]);

  const logOut = async () => {
    await confirmDialog("Are you sure you want to log out?", {
      title: "Log Out",
      confirmText: "Yes, log out",
      color: "failure",
      loadingText: "Logging out...",
      onConfirm: async () => {
        try {
          await apiRequest(
            `${baseUrl}/logout`,
            "POST",
            null,
            localStorage.getItem("royal-token")
          );
          localStorage.removeItem("royal-token");
          navigate("/");
        } catch (error) {
          alert(`Error: ${error.message}`);
        }
      },
    });
  };

  return (
    <Navbar
      fluid
      rounded
      className="
        sticky top-0 z-30
        bg-white/80 dark:bg-gray-900/80
        backdrop-blur-xl
        shadow-sm
        border-b border-gray-200 dark:border-gray-800
      "
    >
      {/* Logo + Branding */}
      <Navbar.Brand as={Link} to="/appointments">
        <div className="flex items-center gap-3">
          <img
            className="h-10 w-10 md:h-12 md:w-12 drop-shadow-sm"
            src={img}
            alt="Royal Mines Logo"
          />

          <span
            className="
              hidden sm:block
              text-blue-600 dark:text-blue-400
              font-extrabold tracking-wide
              text-sm md:text-base leading-tight
              uppercase
            "
          >
            Royalmines
            <br />
            Property
          </span>
        </div>
      </Navbar.Brand>

      <div className="flex md:order-2 items-center gap-2">
        {/* Avatar + Dropdown */}
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <p
              className=" bg-blue-600 text-white
                          h-8 w-8
                          flex items-center justify-center
                          rounded-full
                          ring-2 ring-blue-100
                          hover:scale-105 transition-transform
                          font-semibold text-sm
                        "
            >
              {getInitials(name)}
            </p>
          }
        >
          <Dropdown.Header>
            <span className="block text-sm font-semibold">{name}</span>
            <span className="block truncate text-xs text-gray-500 dark:text-gray-400">
              {loggedInUser?.email}
            </span>
          </Dropdown.Header>

          <Dropdown.Item as={Link} to="/settings">
            Settings
          </Dropdown.Item>

          <Dropdown.Divider />

          <Dropdown.Item
            className="cursor-pointer text-red-600 hover:bg-red-50 dark:hover:bg-red-900/40"
            onClick={logOut}
          >
            Sign out
          </Dropdown.Item>
        </Dropdown>

        {/* Mobile Toggle Button */}
        <Navbar.Toggle
          onClick={toggleSidebar}
          className="hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg p-2 transition"
        />
      </div>
    </Navbar>
  );
}
